// extracted by mini-css-extract-plugin
export default {"textBlock":"HomePage_textBlock__8pD6t","mainHeading":"HomePage_mainHeading__WM6nI","text":"HomePage_text__+HmBu","catalogWrapper":"HomePage_catalogWrapper__L4TNg"};